import RadioButton from './RadioButton';
import { RadioButtonCardProps } from './RadioButtonCard.types';

export const RadioButtonCard = ({
  label,
  desctiption,
  documentRequirement,
  selected,
  onChange,
  classNames
}: RadioButtonCardProps) => {
  const descriptionContent =
    typeof desctiption === 'function' ? desctiption(selected) : desctiption;

  return (
    <button
      onClick={() => onChange(label)}
      className={`group relative w-[374px] p-[17px] flex gap-1 rounded-lg border hover:border-purple-800 focus:shadow-sm focus:ring-1 focus:ring-indigo-500 transition-all outline-none cursor-pointer ${classNames} ${
        selected ? 'bg-blue-50 border-[#4644B6]' : 'bg-white border-gray-250v2'
      }`}
    >
      <RadioButton
        checked={selected}
        onChange={onChange}
        label=""
        name=""
        value=""
      />
      <div
        className={`flex h-full flex-col gap-5 text-sm text-left ${
          selected ? 'text-purple-350' : 'text-gray-550'
        }`}
      >
        <div className="flex h-full flex-col">
          <p
            className={`font-medium ${
              selected ? 'text-purple-900' : 'text-gray-900'
            }`}
          >
            {label}
          </p>
          <div className="flex-1">{descriptionContent}</div>
        </div>
        {documentRequirement && documentRequirement.length > 0 && (
          <ul className="list-disc list-inside">
            Documents required:
            {documentRequirement.map((doc) => (
              <li key={doc} className="ml-2">
                {doc}
              </li>
            ))}
          </ul>
        )}
      </div>
    </button>
  );
};
